import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Periods from './Periods';
import Quarters from './Quarters';
import DirectionIcon from './DirectionIcon';
import { fixDecimals } from '../../../helpers';
import { PracticesAccordionPropsType } from './types';
import { useRouter } from '../../../helpers/customHooks';
import { useTablePropertiesState, useDataEventsState } from '../../../store/hooks';
import { PAST_GAME } from 'config/constants';

const PracticesAccordion = ({ players, forceScope }: PracticesAccordionPropsType) => {
  
  const { pathname, specificScope, search } = useRouter();
  const { dataEvent: data } = useDataEventsState();
  const { orderColumn: orderingBy = 0 } = useTablePropertiesState(forceScope? forceScope : specificScope);
  const prePath = pathname.split('/').splice(0, 6).join('/');
  const [direction, setDirection] = useState(players.map(_ => 'mdi mdi-chevron-down'));
  const periods: JSX.Element[] = [];
  const changeDirection = (index: number) => {
    const aux = [...direction];
    if (direction[index] === 'mdi mdi-chevron-down') {
      aux[index] = 'mdi mdi-chevron-up';
    } else {
      aux[index] = 'mdi mdi-chevron-down';
    }
    setDirection(aux);
  };
  
  useEffect(() => {
    setDirection(players.map(player => 'mdi mdi-chevron-down'));
  }, [orderingBy, players]);
  
  players.sort((first, second) => {
    switch (Math.abs(orderingBy)) {
      case 1:
        return orderingBy === 1 ? first.playerName.localeCompare(second.playerName) :
          first.playerName.localeCompare(second.playerName) * -1;
      case 2:
        return orderingBy === 2 ? first.totalFlights - second.totalFlights :
          second.totalFlights - first.totalFlights;
      case 3:
        return orderingBy === 3 ? first.avgInitAirSpeedInMph - second.avgInitAirSpeedInMph :
          second.avgInitAirSpeedInMph - first.avgInitAirSpeedInMph;
      case 4:
        return orderingBy === 4 ? first.avgInitRotation - second.avgInitRotation :
          second.avgInitRotation - first.avgInitRotation;
      case 5:
        return orderingBy === 5 ? first.avgFlightDurInSec - second.avgFlightDurInSec :
          second.avgFlightDurInSec - first.avgFlightDurInSec;
      case 6:
        return orderingBy === 6 ? first.avgPeakHeightInFeet - second.avgPeakHeightInFeet :
          second.avgPeakHeightInFeet - first.avgPeakHeightInFeet;
      case 7:
        return orderingBy === 7 ? first.avgGroundDistInYards - second.avgGroundDistInYards :
          second.avgGroundDistInYards - first.avgGroundDistInYards;
      default:
        return 0;
    }
  });
  players.forEach((player, index) => {
    periods.push(
      <div key={index} className="group-player">
        <div className="player-00" style={{ width: '150px' }}>
          <div>
            <Link to={{ pathname: prePath + '/modal/' + player.namespaceId, search }}><h6>{player.playerName}</h6></Link>
            <p>
              <label>#{player.jerseyNumber}</label>
              <label>{player.position}</label>
            </p>
          </div>
        </div>
        <div className="accordion-00">
          <Accordion activeKey={direction[index] === 'mdi mdi-chevron-down' ? '1' : '0'}>
            <Card>
              <Card.Header style={{ height: '100px' }}>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                  <div className="table-00" onClick={() => changeDirection(index)}>
                    <div style={{ width: '100px', paddingLeft: '30px', paddingRight: '15px', paddingTop: '10px' }}>
                      <h6>PRACTICE TOTALS</h6>
                    </div>
                    <div style={{ width: '90px', padding: '0px 15px' }}>
                      <p>TOTAL</p>
                      <label>{player.totalFlights}</label>
                    </div>
                    <div>
                      <div style={{ width: '75px', padding: '0px 15px' }}>
                        <p>AVERAGE</p>
                        <label>{fixDecimals(player.avgInitAirSpeedInMph, 1)}</label>
                      </div>
                      <div style={{ width: '75px', padding: '0px 15px' }}>
                        <p>MAX</p>
                        <label>{fixDecimals(player.maxInitAirSpeedInMph, 1)}</label>
                      </div>
                    </div>
                    <div>
                      <div style={{ width: '80px', padding: '0px 15px' }}>
                        <p>AVERAGE</p>
                        <label>{fixDecimals(player.avgInitRotation, 0)}</label>
                      </div>
                      <div style={{ width: '80px', padding: '0px 15px' }}>
                        <p>MAX</p>
                        <label>{fixDecimals(player.maxInitRotation, 0)}</label>
                      </div>
                    </div>
                    <div>
                      <div style={{ width: '95px', padding: '0px 15px' }}>
                        <p>AVERAGE</p>
                        <label>{fixDecimals(player.avgFlightDurInSec, 2)}</label>
                      </div>
                      <div style={{ width: '95px', padding: '0px 15px' }}>
                        <p>MAX</p>
                        <label>{fixDecimals(player.maxFlightDurInSec, 2)}</label>
                      </div>
                    </div>
                    <div>
                      <div style={{ width: '75px', padding: '0px 15px' }}>
                        <p>AVERAGE</p>
                        <label>{fixDecimals(player.avgPeakHeightInFeet, 1)}</label>
                      </div>
                      <div style={{ width: '75px', padding: '0px 15px' }}>
                        <p>MAX</p>
                        <label>{fixDecimals(player.maxPeakHeightInFeet, 1)}</label>
                      </div>
                    </div>
                    <div>
                      <div style={{ width: '75px', padding: '0px 15px' }}>
                        <p>AVERAGE</p>
                        <label>{player.avgGroundDistInYards >= 0 ? fixDecimals(player.avgGroundDistInYards, 1): '-'}</label>
                      </div>
                      <div style={{ width: '75px', padding: '0px 15px' }}>
                        <p>MAX</p>
                        <label>{fixDecimals(player.maxGrounDistInYards, 1)}</label>
                      </div>
                    </div>
                    <div className="icon-00" style={{ paddingTop: '10px' }}>
                      <DirectionIcon dir={direction} index={index} />
                    </div>
                  </div>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>{
                  data.meta.type !== PAST_GAME?
                    <Periods sessionList={player.sessionList}/> :
                    <Quarters quarterList = {player.quarterList}/>
                  }
                  
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
    );
  });
  return <div>{periods}</div>;
};

export default PracticesAccordion;